import React, { useCallback } from 'react';
import { SectionPanel } from 'ui';
import { SecondaryTextMode, TranslationsComponent } from 'app/components/translation';
import { MetroLineSection } from 'app/components/metro-line/metro-line-section';
import { ImportSetSectionType } from '../metroline/types';
import { languageValidationParameter, maxDescriptionLength } from '../constants';
import { ImportSetLanguageProps } from '../types';

export const ImportSetLanguage: React.FC<ImportSetLanguageProps> = ({
  language, mainLanguage, languageOptions, showTranslations, validation, translation, section,
  getRef, switchTranslationsToggle, shouldRenderSection, changeLanguage, copyLanguageToAll
}) => {

  const copyDescriptionToAll = useCallback(() => {
    copyLanguageToAll(mainLanguage, translation.copied_description_to_all);
  }, [mainLanguage, translation]);

  return <MetroLineSection<ImportSetSectionType>
    section={section}
    sectionType={ImportSetSectionType.Translations}
    getRef={getRef}
    shouldRenderSection={shouldRenderSection}>
    <div ref={getRef(ImportSetSectionType.Translations)}>
      <SectionPanel
        className="admin-paper-top-panel"
        componentId={ImportSetSectionType.Translations}
        validation={undefined}
        info={{ text: translation.descriptions_and_translations }}
        label={{ visible: true, text: translation.descriptions_and_translations }} />
      <TranslationsComponent
        primaryText={language}
        secondaryText={undefined}
        primaryTextValueKey={languageValidationParameter}
        secondaryTextValueKey={undefined}
        primaryTextMaxLength={maxDescriptionLength}
        secondaryTextMaxLength={undefined}
        languageOptions={languageOptions}
        mainLanguage={mainLanguage}
        secondaryTextMode={SecondaryTextMode.disabled}
        readOnly={false}
        onPrimaryTextChange={changeLanguage}
        onSecondaryTextChange={undefined}
        copyPrimaryTextToAllTranslations={copyDescriptionToAll}
        copySecondaryTextToAllTranslations={undefined}
        hasTranslationsToggled={showTranslations}
        switchTranslationsToggle={switchTranslationsToggle}
        validation={validation?.language}
        primaryTextLabel={translation?.description}
        secondaryTextLabel={undefined}
        copyPrimaryTextToAllLabel={translation?.copy_description_to_all}
        copySecondaryTextToAllLabel={undefined}
        translationsHeaderLabel={translation?.translations_header}
        switchTranslationsToggleLabel={translation?.show_translations} />
    </div>
  </MetroLineSection>;
};
